import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchMyTimesheetWeek, submitTimesheet } from '../api/timesheet.api';

export const TIME_KEYS = {
  week: (weekStart: string) => ['timesheet', 'me', weekStart] as const,
};

export function useMyTimesheetWeek(weekStart: string) {
  return useQuery({
    queryKey: TIME_KEYS.week(weekStart),
    queryFn: () => fetchMyTimesheetWeek(weekStart),
    staleTime: 0,
    // Poll every 30 seconds so deactivated issues disappear from the timesheet
    // for other users without requiring a manual page refresh.
    refetchInterval: 30_000,
  });
}

// Submit — locks entries until an approver acts. Invalidates the whole ['timesheet'] prefix
// (own week view + the Lead-facing ['timesheet-approvals'] queries a Lead reviewing their own
// timesheet in the same session would also have cached) — same reasoning as
// useApproveTimesheetWeek/useRejectTimesheetWeek's invalidateApprovalQueries.
export function useSubmitTimesheet() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ weekStart, projectId }: { weekStart: string; projectId?: string }) => submitTimesheet(weekStart, projectId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['timesheet'] });
      void queryClient.invalidateQueries({ queryKey: ['timesheet-approvals'] });
    },
  });
}
